import { render } from "./Listbox.vue?vue&type=template&id=5284ed17"
import script from "./Listbox.vue?vue&type=script&lang=js"
export * from "./Listbox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__